import { PathMembershipSectionItems } from "@src/components/libraryItemDetailPages/module/hooks/usePathMembershipItems";

const moduleStartsWithSectionBreak = (
  membershipSections: PathMembershipSectionItems[],
): boolean => {
  return membershipSections.length > 0;
};

export default moduleStartsWithSectionBreak;
